// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCopy_root__2P5Wj"};